import React from 'react';
import cx from 'clsx';
import styles from './Label.module.scss';

const Label = ({ children, required, className, size, ...rest }) => {
  const setClass = (size) => {
    switch (size) {
      case size:
        return styles[size];
      default:
        return '';
    }
  };

  return (
    <label className={cx('body-12-medium', styles.label, className, setClass(size))} {...rest}>
      {children} {required && <sup>*</sup>}
    </label>
  );
};

export default Label;
